<template>
    <header style="background-color:#33106b" class="sticky-top">
        <div class="container">
            <div class="logo text-center">
                <img alt="Logo" src="/media/logos/fisu_fedup_white.png" class="h-50px h-lg-60px my-4" />
            </div>
        </div>
    </header>
</template>